import { DataCollectionRecord } from '@ltvco/refresh-lib/hooks';
import { NoResultsFound } from '@ltvco/refresh-lib/v2';

import { CollectionRecordCards } from '../Cards/CollectionRecordCards';
import { PersonCardLoading } from '../Loading/PersonCardLoading';

interface CollectionRecordsResultsContainerProps {
  results: DataCollectionRecord[] | undefined;
  tabName?: string;
}

export function CollectionRecordsResultsContainer({
  results,
  tabName,
}: CollectionRecordsResultsContainerProps) {
  return !results ? (
    <PersonCardLoading />
  ) : results.length === 0 ? (
    <NoResultsFound />
  ) : (
    <CollectionRecordCards records={results} tabName={tabName} />
  );
}
